<template>
  <div id="list_quote">
    <Header />
    <LeftNav />
    <main id="page-wrap">
      <b-container fluid>
        <FilterBar />
        <QuoteListTable />
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/layout/AppHeader.vue";
import Footer from "@/components/common/layout/AppFooter.vue";
import QuoteListTable from "@/components/common/layout/QuoteListTable";
import LeftNav from "@/components/common/layout/AppLeftNav";
import FilterBar from "@/components/vuetable/FilterBar.vue";

export default {
  name: "list_quote",
  components: {
    Header,
    Footer,
    QuoteListTable,
    LeftNav,
    FilterBar
  }
};
</script>

<style scoped>
.row-top-list {
  margin-top: 40px;
}
</style>

<i18n>
{
  "en": {
    "search_panel": "Search Panel",
    "list_quotaion": "Quotation List"
  },
  "si": {
    "search_panel": "සෙවුම් පැනලය",
    "list_quotaion": "ලැයිස්තු උපුටා දැක්වීම"
  }
}
</i18n>
